/** Extract a human-readable title from generated HTML. */
export function extractHtmlPageTitle(html: string): string {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const title = doc.querySelector('title')?.textContent?.trim()
    if (title) return title
    const h1 = doc.querySelector('h1')?.textContent?.trim()
    if (h1) return h1
  } catch {
    /* ignore parse errors */
  }
  return 'My webpage'
}

/** Lowercase slug safe for `POST /websites/check-slug` (3–200 chars). */
export function slugifyWebsiteName(name: string): string {
  const slug = name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 200)
    // Re-trim: the 200-char cut can land right after a hyphen and re-introduce a
    // trailing '-', which `isValidWebsiteSlug` and the backend both reject.
    .replace(/-+$/, '')

  if (slug.length >= 3) return slug
  return `page-${Date.now().toString(36)}`.slice(0, 200)
}

export function isValidWebsiteSlug(slug: string): boolean {
  if (slug.length < 3 || slug.length > 200) return false
  return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(slug)
}

/** Absolute URL for a website `link` path (e.g. `/w/my-slug`). */
export function websitePublicHref(link: string): string {
  const relative = link.replace(/^\//, '')
  const originBase = `${window.location.origin}${
    import.meta.env.BASE_URL || '/'
  }`
  const base = originBase.endsWith('/') ? originBase : `${originBase}/`
  return new URL(relative, base).href
}
